function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useRevalidator } from 'react-router-dom';
import { useSetAtom } from 'jotai';

import { Translate } from "../../../../../I18N";
import { FetchResponseError } from "../../../../../../shared/JSONRequest";
import { Button, Card, Sidepanel } from "../../../../Components/UI";
import { InputField } from "../../../../Components/Forms";
import { getFileNameAndExtension } from "../../../../shared/formatHelpers";
import { notificationAtom } from "../../../../atoms";
import { update } from "../../../../api/files";








const EditFileSidepanel = ({ showSidepanel, closeSidepanel, file }) => {var _errors$filename;
  const { name, extension } = getFileNameAndExtension(file === null || file === void 0 ? void 0 : file.originalname);
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);

  const notify = (response) => {
    const hasErrors = response instanceof FetchResponseError;

    if (!hasErrors) {
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "File updated")
      });
    }

    if (hasErrors) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: response.message
      });
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {},
    values: { filename: name }
  });

  const save = async (data) => {
    const updatedFile = _objectSpread(_objectSpread({}, file), {}, { originalname: `${data.filename}.${extension}` });
    delete updatedFile.rowId;
    const response = await update(updatedFile);
    closeSidepanel();
    notify(response);
    revalidator.revalidate();
  };

  return (/*#__PURE__*/
    _jsx(Sidepanel, {
      isOpen: showSidepanel,
      withOverlay: true,
      closeSidepanelFunction: isSubmitting ? () => {} : closeSidepanel,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit File") }, void 0, /*#__PURE__*/

    _jsx("form", { onSubmit: handleSubmit(save), className: "flex flex-col h-full", id: "file-edit-form" }, void 0, /*#__PURE__*/
    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx(Card, { title: /*#__PURE__*/_jsx(Translate, {}, void 0, "General Information") }, void 0, /*#__PURE__*/
    _jsx("div", { className: "mb-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      label: /*#__PURE__*/_jsx(Translate, { className: "block mb-1 font-semibold" }, void 0, "File name"),
      id: "filename",
      errorMessage: ((_errors$filename = errors.filename) === null || _errors$filename === void 0 ? void 0 : _errors$filename.type) === 'required' && 'This field is required',
      autoComplete: "off",
      className: "mb-1" },
    register('filename', {
      required: true
    }))
    )
    )
    )
    )
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 w-full" }, void 0, /*#__PURE__*/
    _jsx(Button, { className: "grow", styling: "light", disabled: isSubmitting, onClick: closeSidepanel }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", disabled: isSubmitting, form: "file-edit-form" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ));

};

export { EditFileSidepanel };